<template lang="pug">
  .legend__group
    .legend__type
      label.legend__switch.switch
        span.semibold.legend__name Кадастровые границы
        input.visually-hidden.switch__input(
          type="checkbox"
          v-model="showCadastre"
          @change="toggleCadastre"
        )
        span.switch__block
</template>

<script>
import routeMixin from '@/mixins/route-mixin'

export default {
  name: 'map-heat',
  mixins: [routeMixin],
  data: () => ({
    showCadastre: false,
  }),
  methods: {
    toggleCadastre(e) {
      this.$emit(
        'rosreestrChangeView',
        e.target.checked ? 'rosreestr_cadastre' : 'osm'
      )
    },
  },
}
</script>
